export default [
  {
    TotalDelivered: "0",
    TotalDND: "0",
    TotalOptout: "0",
    Date: "13 Nov 2021",
    TotalNumber: "0",
    TotalFailed: "0",
    campaignid: "1q2we4",
    type: "SMS",
  },
  {
    TotalDelivered: "0",
    TotalDND: "0",
    TotalOptout: "0",
    Date: "14 Nov 2021",
    TotalNumber: "0",
    TotalFailed: "0",
    campaignid: "1q2we4",
    type: "Email",
  },
  {
    TotalDelivered: "0",
    TotalDND: "0",
    TotalOptout: "0",
    Date: "14 Nov 2021",
    TotalNumber: "0",
    TotalFailed: "0",
    campaignid: "1q2we4",
    type: "Voiceblast",
  },
];
